import authService from '../../services/api/AuthenticationService';

export const GET_TRANSFER_SUCCESS = "auth/GET_TRANSFER_SUCCESS";
export const GET_TRANSFER_FAIL = "auth/GET_TRANSFER_FAIL";

export function getTransferInfoSuccess(result) {
    return {type: GET_TRANSFER_SUCCESS, transferInfo: result};
}

export function getTransferInfoFail(err) {
    return {type: GET_TRANSFER_FAIL, error: err};
}

export function getTransferInfo(nonce) {
    return function (dispatch) {
        return authService.getTransferInfo(nonce)
            .then((result) => dispatch(getTransferInfoSuccess(result)))
            .catch((err) => dispatch(getTransferInfoFail(err)));
    };
}
